<template>
  <router-view :key="'settings_' + $route.path" />
</template>
<script>
export default {
  mounted() {
    this.$store.state.inner_sidebar = [];

    this.$store.state.breadcrumbs = {
      title: "Instellingen",
      links: [
        {
          title: "Instellingen",
          href: "/settings",
        },
      ],
    };

    let menus = [];

    let emails = [];

    if (this.userHasPermissions(["Beheer Mailtemplates"])) {
      emails.push({
        title: "Mailtemplates",
        href: "/settings/mailtemplates",
        children: [],
      });
    }

    if (this.userHasPermissions(["Beheer Emailadressen"])) {
      emails.push({
        title: "Emailadressen",
        href: "/settings/emailaddresses",
        children: [],
      });
    }

    if (
      this.userHasPermissions(["Beheer Mailtemplates", "Beheer Emailadressen"])
    ) {
      menus.push({
        title: "Email",
        href: "#",
        children: emails,
      });
    }

    let informatie = [];

    if (this.userHasPermissions(["Beheer Informatie"])) {
      informatie.push({
        title: "Informatie",
        href: "/settings/itemgroups",
        children: [],
      });
    }

    if (this.userHasPermissions(["Beheer Informatie"])) {
      informatie.push({
        title: "Itemtypes",
        href: "/settings/itemtypes",
        children: [],
      });
    }

    if (this.userHasPermissions(["Beheer Informatie"])) {
      menus.push({
        title: "Informatie",
        href: "#",
        children: informatie,
      });
    }

    let finance = [];

    if (this.userHasPermissions(["Financieel"])) {
      finance.push({
        title: "Betaalproviders",
        href: "/settings/payment-providers",
        children: [],
      });
    }

    if (this.userHasPermissions(["Financieel"])) {
      finance.push({
        title: "Betaalmethoden",
        href: "/settings/payment-methods",
        children: [],
      });
    }

    if (this.userHasPermissions(["Financieel"])) {
      finance.push({
        title: "Abonnementen",
        href: "/settings/subscriptions",
        children: [],
      });
    }

    if (this.userHasPermissions(["Financieel"])) {
      menus.push({
        title: "Financieel",
        href: "#",
        children: finance,
      });
    }

    let activities = [];

    if (this.userHasPermissions(["Beheer Activiteiten"])) {
      activities.push({
        title: "Activiteittypen",
        href: "/settings/list/eventtypes",
        children: [],
      });
    }

    if (this.userHasPermissions(["Beheer Activiteiten"])) {
      menus.push({
        title: "Activiteiten",
        href: "#",
        children: activities,
      });
    }

    // if (this.userHasPermissions(["Beheer Groepen", "Beheer Commissies"])) {
    //   menus.push({
    //     title: "Aanmaken",
    //     href: "#",
    //     children: [
    //       {
    //         title: "Commissie",
    //         href: "/settings/create/committee",
    //         children: [],
    //       },
    //       {
    //         title: "Groep",
    //         href: "/settings/create/group",
    //         children: [],
    //       },
    //     ],
    //   });
    // }

    let association = [];

    if (this.userHasPermissions(["Beheer Informatie"])) {
      association.push({
        title: "Vereniging",
        href: "/settings/community/settings",
        children: [],
      });
    }

    if (this.userHasPermissions(["Beheer Commissies"])) {
      association.push({
        title: "Commissies",
        href: "/settings/committees",
        children: [],
      });
    }

    if (this.userHasPermissions(["Beheer Groepen"])) {
      association.push({
        title: "Groepen",
        href: "/settings/groups",
        children: [],
      });
    }

    if (
      this.userHasPermissions([
        "Financieel",
        "Beheer Groepen",
        "Beheer Commissies",
        "Beheer Informatie",
      ])
    ) {
      menus.push({
        title: "Vereniging",
        href: "#",
        children: association,
      });
    }

    if (this.userHasRoles(["Super-Admin"])) {
      menus.push({
        title: "Help",
        href: "/settings/help",
        children: [],
      });
    }

    this.$store.state.inner_sidebar = menus;

    if (this.$route.meta.Breadcrumb) {
      this.$store.commit("addBreadcrumb", {
        title: this.$route.meta.Breadcrumb,
        href: this.$route.path,
      });
    }
  },
};
</script>
